import React, { Component } from "react";
import { Grid, Form } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InlineError from "../../messages/InlineError";

class DobControl extends Component {
  constructor(props) {
    super(props);
    const date = this.getDate(props);
    this.state = {
      date
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ date: this.getDate(nextProps) });
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      const element = document.getElementById(nextProps.control.FieldId);
      if (element) element.focus();
    }
  }

  getDate = (props) => {
    if (props.defaultData !== undefined && props.defaultData.dobDay !== undefined) {
      const { dobDay, dobMonth, dobYear } = props.defaultData;
      const date = new Date(dobYear, dobMonth - 1, dobDay);
      return date;
    }
    return null;
  }

  handleChange = (date) => {
    this.setState({ date });

    if (!date) {
      ["dobMonth", "dobDay", "dobYear", "dob"].forEach((field) =>
        this.props.notifyChangeToForm(this, { name: field, value: NaN })
      );
      return;
    }

    const dobEncoded = `${date.getMonth() + 1}%2F${date.getDate()}%2F${date.getFullYear()}`;
    this.props.notifyChangeToForm(this, { name: "dobMonth", value: date.getMonth() + 1 });
    this.props.notifyChangeToForm(this, { name: "dobDay", value: date.getDate() });
    this.props.notifyChangeToForm(this, { name: "dobYear", value: date.getFullYear() });
    this.props.notifyChangeToForm(this, { name: "dob", value: encodeURI(dobEncoded) });
  }

  render() {
    const { control, isLeftSearch } = this.props;
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`drop_${control.FieldId}`}>
        {control.controlLabel !== "" &&
          (this.props.hideLabel === undefined || !this.props.hideLabel) ? (
          <Grid.Column width={isLeftSearch ? 6 : 6}>
            <Form.Field>
              <label
                htmlFor={control.FieldLabel}
                style={{ color, marginBottom: "0px" }}
                className="padding-10 full-width-datepicker-wrapper"
              >
                {control.FieldLabel}
              </label>
            </Form.Field>
          </Grid.Column>
        ) : null}
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field error={!!control.error} style={{ width: "100%", marginBottom: "0px" }}>
            <div className="full-width-datepicker-wrapper">
              <DatePicker
                id={control.FieldId}
                name="dob"
                placeholderText="Select a date"
                selected={this.state.date}
                showMonthDropdown
                showYearDropdown
                closable
                dateFormat="MM/dd/yyyy"
                className="full-width-datepicker"
                onChange={this.handleChange}
              />
            </div>

            {this.props.errors[control.FieldName] && (
              <InlineError text={this.props.errors[control.FieldName]} />
            )}
          </Form.Field>
        </Grid.Column>

      </Grid.Row>
    );
  }
}

export default DobControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/DobControl.js